import { type PaymentType } from '@wix/ambassador-forms-v4-form/types';

import { SelectMode } from '../../../../field-settings/settings-shared/options/options-list/types';

export function getSelectMode({
  maxItems,
  products,
}: PaymentType = {}): SelectMode {
  if (maxItems === 1) {
    return SelectMode.onlyOne;
  }
  if (
    products?.length &&
    products.every(
      (product) => typeof product.quantityLimit?.maximum === 'undefined',
    )
  ) {
    return SelectMode.many;
  }
  return SelectMode.oneByOne;
}
